import * as Icons from "@mui/icons-material";
import { sFeedMgt } from "../Strings";
export const SidebarData = [
  {
    title: "Home",
    link: "/home",
    icon: Icons.Home,
  },
  {
    title: "App",
    icon: Icons.PhoneIphone,
    subs: [
      {
        title: "Top Banner",
        link: "/app/banner",
      },
      {
        title: sFeedMgt,
        link: "/app/feed",
      },
    ],
  },
  {
    title: "Products",
    icon: Icons.LocalMall,
    link: "/products",
    // subs: [
    //   {
    //     title: "Add Product",
    //     link: "/product/add",
    //   },
    //   {
    //     title: "View Products",
    //     link: "/product/view",
    //   },
    // ],
  },
  {
    title: "Categories",
    link: "/categories",
    icon: Icons.Category,
  },
  {
    title: "Orders",
    link: "/orders",
    icon: Icons.Inventory,
  },
  {
    title: "Users",
    link: "/users",
    icon: Icons.Person,
  },
  {
    title: "Notifications",
    link: "/notifications",
    icon: Icons.Notifications,
  },
  {
    title: "Configuration",
    link: "/config",
    icon: Icons.Settings,
  },
  {
    title: "More",
    link: "/more",
    icon: Icons.More,
  },
];
